// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Modal = require("../ui-utils/Modal.bs.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_wrk_LoadCtx = require("../worker/MM_wrk_LoadCtx.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var MM_wrk_ParseMmFile = require("../worker/MM_wrk_ParseMmFile.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var AccordionSummaryStyled = require("../ui-utils/AccordionSummaryStyled.bs.js");
var Add = require("@mui/icons-material/Add").default;
var Accordion = require("@mui/material/Accordion").default;
var IconButton = require("@mui/material/IconButton").default;
var ExpandMore = require("@mui/icons-material/ExpandMore").default;
var AccordionDetails = require("@mui/material/AccordionDetails").default;
var MM_cmp_context_selector_single = require("./MM_cmp_context_selector_single.bs.js");

function readInstrFromStr(str) {
  switch (str) {
    case "all" :
        return "all";
    case "stopAfter" :
        return "stopAfter";
    case "stopBefore" :
        return "stopBefore";
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert string '" + str + "' to a readInstr."
            },
            Error: new Error()
          };
  }
}

function createEmptySingleScope(id) {
  return {
          id: id,
          fileName: undefined,
          fileText: undefined,
          ast: undefined,
          allLabels: [],
          readInstr: "all",
          label: undefined
        };
}

function setFileName(ss, fileName) {
  return {
          id: ss.id,
          fileName: fileName,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setFileText(ss, fileText) {
  return {
          id: ss.id,
          fileName: ss.fileName,
          fileText: fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setAst(ss, ast) {
  return {
          id: ss.id,
          fileName: ss.fileName,
          fileText: ss.fileText,
          ast: ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setAllLabels(ss, allLabels) {
  return {
          id: ss.id,
          fileName: ss.fileName,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setReadInstr(ss, readInstr) {
  return {
          id: ss.id,
          fileName: ss.fileName,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: readInstr,
          label: ss.label
        };
}

function setLabel(ss, label) {
  return {
          id: ss.id,
          fileName: ss.fileName,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: label
        };
}

function reset(ss) {
  return createEmptySingleScope(ss.id);
}

function addSingleScope(st) {
  return {
          nextId: st.nextId + 1 | 0,
          expanded: st.expanded,
          singleScopes: Belt_Array.concat(st.singleScopes, [createEmptySingleScope(String(st.nextId))]),
          loadedContextSummary: st.loadedContextSummary
        };
}

function updateSingleScope(st, id, update) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes.map(function (ss) {
                if (ss.id === id) {
                  return Curry._1(update, ss);
                } else {
                  return ss;
                }
              }),
          loadedContextSummary: st.loadedContextSummary
        };
}

function deleteSingleScope(st, id) {
  var st_nextId = st.nextId;
  var st_expanded = st.expanded;
  var st_singleScopes = Belt_Array.keep(st.singleScopes, (function (ss) {
          return ss.id !== id;
        }));
  var st_loadedContextSummary = st.loadedContextSummary;
  var st$1 = {
    nextId: st_nextId,
    expanded: st_expanded,
    singleScopes: st_singleScopes,
    loadedContextSummary: st_loadedContextSummary
  };
  if (st_singleScopes.length === 0) {
    return addSingleScope(st$1);
  } else {
    return st$1;
  }
}

function setExpanded(st, expanded) {
  return {
          nextId: st.nextId,
          expanded: expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: st.loadedContextSummary
        };
}

function setLoadedContextSummary(st, loadedContextSummary) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: loadedContextSummary
        };
}

function getSummary(st) {
  if (st.singleScopes.length === 1 && Belt_Option.isNone(Caml_array.get(st.singleScopes, 0).fileName)) {
    return "Empty MM context is loaded.";
  }
  var filesInfo = st.singleScopes.map(function (ss) {
        var fileName = Belt_Option.getWithDefault(ss.fileName, "");
        var match = ss.readInstr;
        var readInstr = match === "all" ? "" : (
            match === "stopAfter" ? ", stopped after '" + Belt_Option.getWithDefault(ss.label, "") + "'" : ", stopped before '" + Belt_Option.getWithDefault(ss.label, "") + "'"
          );
        return fileName + readInstr;
      });
  return "Loaded: " + filesInfo.join("; ");
}

function MM_cmp_context_selector(Props) {
  var onChange = Props.onChange;
  var modalRef = Props.modalRef;
  var match = React.useState(function () {
        return {
                nextId: 1,
                expanded: true,
                singleScopes: [{
                    id: "0",
                    fileName: undefined,
                    fileText: undefined,
                    ast: undefined,
                    allLabels: [],
                    readInstr: "all",
                    label: undefined
                  }],
                loadedContextSummary: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return state;
      });
  var setPrevState = match$1[1];
  var prevState = match$1[0];
  React.useEffect((function () {
          Curry._1(setState, (function (prev) {
                  return setLoadedContextSummary(prev, getSummary(prev));
                }));
        }), []);
  var actNewCtxIsReady = function (ctx) {
    Curry._1(setState, (function (st) {
            var st$1 = setLoadedContextSummary(st, getSummary(st));
            Curry._1(setPrevState, (function (param) {
                    return st$1;
                  }));
            return st$1;
          }));
    Curry._1(onChange, ctx);
  };
  var rndParseMmFileProgress = function (fileName, pct) {
    return Modal.rndProgress("Parsing " + fileName + "", pct);
  };
  var toggleAccordion = function (param) {
    Curry._1(setState, (function (prev) {
            return setExpanded(prev, !prev.expanded);
          }));
  };
  var rndSingleScopeSelectors = function (param) {
    var renderDeleteButton = state.singleScopes.length > 1 || Belt_Option.isSome(Caml_array.get(state.singleScopes, 0).fileName);
    return state.singleScopes.map(function (singleScope) {
                var match = singleScope.ast;
                var tmp;
                tmp = match !== undefined && match.TAG !== /* Ok */0 ? match._0 : undefined;
                return React.createElement(MM_cmp_context_selector_single.make, {
                            onFileChange: (function (__x) {
                                var id = singleScope.id;
                                if (__x === undefined) {
                                  return Curry._1(setState, (function (__x) {
                                                return updateSingleScope(__x, id, reset);
                                              }));
                                }
                                var text = __x[1];
                                var name = __x[0];
                                Expln_utils_promise.promiseMap(Modal.openModal(modalRef, (function (param) {
                                            return rndParseMmFileProgress(name, 0);
                                          })), (function (modalId) {
                                        MM_wrk_ParseMmFile.beginParsingMmFile(text, (function (pct) {
                                                Modal.updateModal(modalRef, modalId, (function (param) {
                                                        return rndParseMmFileProgress(name, pct);
                                                      }));
                                              }), (function (parseResult) {
                                                Curry._1(setState, (function (__x) {
                                                        return updateSingleScope(__x, id, (function (__x) {
                                                                      return setFileName(__x, name);
                                                                    }));
                                                      }));
                                                Curry._1(setState, (function (__x) {
                                                        return updateSingleScope(__x, id, (function (__x) {
                                                                      return setFileText(__x, text);
                                                                    }));
                                                      }));
                                                Curry._1(setState, (function (__x) {
                                                        return updateSingleScope(__x, id, (function (__x) {
                                                                      return setReadInstr(__x, "all");
                                                                    }));
                                                      }));
                                                Curry._1(setState, (function (__x) {
                                                        return updateSingleScope(__x, id, (function (__x) {
                                                                      return setLabel(__x, undefined);
                                                                    }));
                                                      }));
                                                if (parseResult.TAG === /* Ok */0) {
                                                  var match = parseResult._0;
                                                  var allLabels = match[1];
                                                  var ast = match[0];
                                                  Curry._1(setState, (function (__x) {
                                                          return updateSingleScope(__x, id, (function (__x) {
                                                                        return setAst(__x, {
                                                                                    TAG: /* Ok */0,
                                                                                    _0: ast
                                                                                  });
                                                                      }));
                                                        }));
                                                  Curry._1(setState, (function (__x) {
                                                          return updateSingleScope(__x, id, (function (__x) {
                                                                        return setAllLabels(__x, allLabels);
                                                                      }));
                                                        }));
                                                } else {
                                                  var msg = parseResult._0;
                                                  Curry._1(setState, (function (__x) {
                                                          return updateSingleScope(__x, id, (function (__x) {
                                                                        return setAst(__x, {
                                                                                    TAG: /* Error */1,
                                                                                    _0: msg
                                                                                  });
                                                                      }));
                                                        }));
                                                  Curry._1(setState, (function (__x) {
                                                          return updateSingleScope(__x, id, (function (__x) {
                                                                        return setAllLabels(__x, []);
                                                                      }));
                                                        }));
                                                }
                                                Modal.closeModal(modalRef, modalId);
                                              }));
                                      }));
                              }),
                            fileName: singleScope.fileName,
                            parseError: tmp,
                            readInstr: singleScope.readInstr,
                            onReadInstrChange: (function (readInstrStr) {
                                Curry._1(setState, (function (__x) {
                                        return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                      return setReadInstr(__x, readInstrFromStr(readInstrStr));
                                                    }));
                                      }));
                              }),
                            label: singleScope.label,
                            onLabelChange: (function (labelOpt) {
                                Curry._1(setState, (function (__x) {
                                        return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                      return setLabel(__x, labelOpt);
                                                    }));
                                      }));
                              }),
                            allLabels: singleScope.allLabels,
                            renderDeleteButton: renderDeleteButton,
                            onDelete: (function (param) {
                                Curry._1(setState, (function (__x) {
                                        return deleteSingleScope(__x, singleScope.id);
                                      }));
                              }),
                            key: singleScope.id
                          });
              });
  };
  var rndAddButton = function (param) {
    var thereIsAtLeastOneValidSingleScope = state.singleScopes.some(function (singleScope) {
          var match = singleScope.ast;
          if (match !== undefined && match.TAG === /* Ok */0) {
            return true;
          } else {
            return false;
          }
        });
    if (thereIsAtLeastOneValidSingleScope) {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(setState, addSingleScope);
                    }),
                  children: React.createElement(Add, {}),
                  key: "add-button"
                });
    } else {
      return null;
    }
  };
  var scopeIsEmpty = state.singleScopes.length === 1 && Belt_Option.isNone(Caml_array.get(state.singleScopes, 0).fileName);
  var rndSaveButtons = function (param) {
    var thereAreNoChanges = Caml_obj.equal(state.singleScopes, prevState.singleScopes);
    if (thereAreNoChanges) {
      return null;
    }
    var scopeIsCorrect = state.singleScopes.every(function (ss) {
          var match = ss.ast;
          if (match === undefined) {
            return false;
          }
          if (match.TAG !== /* Ok */0) {
            return false;
          }
          var match$1 = ss.readInstr;
          if (match$1 === "all") {
            return true;
          } else {
            return ss.label !== undefined;
          }
        });
    return React.createElement(Expln_React_Row.make, {
                children: React.createElement(Button, {
                      onClick: (function (param) {
                          if (scopeIsEmpty) {
                            return actNewCtxIsReady(MM_context.createContext(undefined, undefined));
                          } else {
                            Expln_utils_promise.promiseMap(Modal.openModal(modalRef, (function (param) {
                                        return Modal.rndProgress("Loading MM context", 0);
                                      })), (function (modalId) {
                                    MM_wrk_LoadCtx.beginLoadingMmContext(state.singleScopes.map(function (ss) {
                                              var stopBefore = ss.readInstr === "stopBefore" ? ss.label : undefined;
                                              var stopAfter = ss.readInstr === "stopAfter" ? ss.label : undefined;
                                              var label = Belt_Option.getWithDefault(stopBefore, Belt_Option.getWithDefault(stopAfter, Belt_Option.getWithDefault(Belt_Array.get(ss.allLabels, ss.allLabels.length - 1 | 0), "")));
                                              var match = ss.ast;
                                              var tmp;
                                              if (match !== undefined) {
                                                if (match.TAG === /* Ok */0) {
                                                  tmp = match._0;
                                                } else {
                                                  throw {
                                                        RE_EXN_ID: MM_parser.MmException,
                                                        _1: {
                                                          msg: "Cannot load an MM context from an empty or error ast."
                                                        },
                                                        Error: new Error()
                                                      };
                                                }
                                              } else {
                                                throw {
                                                      RE_EXN_ID: MM_parser.MmException,
                                                      _1: {
                                                        msg: "Cannot load an MM context from an empty or error ast."
                                                      },
                                                      Error: new Error()
                                                    };
                                              }
                                              return {
                                                      ast: tmp,
                                                      expectedNumOfAssertions: ss.allLabels.indexOf(label) + 1 | 0,
                                                      stopBefore: stopBefore,
                                                      stopAfter: stopAfter
                                                    };
                                            }), (function (pct) {
                                            Modal.updateModal(modalRef, modalId, (function (param) {
                                                    return Modal.rndProgress("Loading MM context", pct);
                                                  }));
                                          }), (function (ctx) {
                                            if (ctx.TAG === /* Ok */0) {
                                              actNewCtxIsReady(ctx._0);
                                              Curry._1(setState, (function (__x) {
                                                      return setExpanded(__x, false);
                                                    }));
                                            } else {
                                              var msg = ctx._0;
                                              Expln_utils_promise.promiseMap(Modal.openModal(modalRef, (function (param) {
                                                          return null;
                                                        })), (function (modalId) {
                                                      Modal.updateModal(modalRef, modalId, (function (param) {
                                                              return React.createElement(Paper, {
                                                                          style: {
                                                                            padding: "10px"
                                                                          },
                                                                          children: React.createElement(Expln_React_Column.make, {
                                                                                spacing: 1,
                                                                                children: null
                                                                              }, "Error loading context:", React.createElement("pre", {
                                                                                    style: {
                                                                                      color: "red"
                                                                                    }
                                                                                  }, msg), React.createElement(Button, {
                                                                                    onClick: (function (param) {
                                                                                        Modal.closeModal(modalRef, modalId);
                                                                                      }),
                                                                                    variant: "contained",
                                                                                    children: "Ok"
                                                                                  }), React.createElement(Expln_React_Row.make, {}))
                                                                        });
                                                            }));
                                                    }));
                                            }
                                            Modal.closeModal(modalRef, modalId);
                                          }));
                                  }));
                            return ;
                          }
                        }),
                      variant: "contained",
                      disabled: !scopeIsCorrect && !scopeIsEmpty,
                      children: "Apply changes"
                    })
              });
  };
  return React.createElement(Accordion, {
              expanded: state.expanded,
              children: null
            }, React.createElement(AccordionSummaryStyled.make, {
                  onClick: toggleAccordion,
                  expandIcon: React.createElement(ExpandMore, {}),
                  children: state.loadedContextSummary
                }), React.createElement(AccordionDetails, {
                  children: React.createElement(Expln_React_Column.make, {
                        spacing: 2,
                        children: null
                      }, rndSingleScopeSelectors(undefined), rndAddButton(undefined), rndSaveButtons(undefined))
                }));
}

var make = MM_cmp_context_selector;

exports.readInstrFromStr = readInstrFromStr;
exports.createEmptySingleScope = createEmptySingleScope;
exports.setFileName = setFileName;
exports.setFileText = setFileText;
exports.setAst = setAst;
exports.setAllLabels = setAllLabels;
exports.setReadInstr = setReadInstr;
exports.setLabel = setLabel;
exports.reset = reset;
exports.addSingleScope = addSingleScope;
exports.updateSingleScope = updateSingleScope;
exports.deleteSingleScope = deleteSingleScope;
exports.setExpanded = setExpanded;
exports.setLoadedContextSummary = setLoadedContextSummary;
exports.getSummary = getSummary;
exports.make = make;
/* Modal Not a pure module */
